import { useState, useEffect } from 'react'
import { Download as DownloadIcon, Smartphone, Info } from 'lucide-react'

const Download = () => {
  const [apks, setApks] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    loadAPKs()
  }, [])

  const loadAPKs = async () => {
    try {
      setLoading(true)
      const response = await fetch('/api/apks')
      const data = await response.json()
      
      if (data.success) {
        setApks(data.apks)
      } else {
        setError(data.message || 'Error al cargar APKs')
      }
    } catch (error) {
      setError('Error de conexión')
    } finally {
      setLoading(false)
    }
  }

  const handleDownload = (apk) => {
    if (!apk.exists) {
      alert('Este APK no está disponible para descarga')
      return
    }
    
    // Crear enlace de descarga
    const link = document.createElement('a')
    link.href = `/api/apks/${apk.id}/download`
    link.download = apk.filename
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-red-600 mb-4">Error</h1>
          <p className="text-gray-600">{error}</p>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            📱 Descargar Aplicaciones
          </h1>
          <p className="text-gray-600">
            Selecciona la aplicación que deseas descargar
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {apks.map((apk) => (
            <div key={apk.id} className="bg-white rounded-lg shadow-md p-6 border">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-3">
                  <Smartphone className="w-6 h-6 text-blue-600" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">{apk.displayName}</h3>
                  <p className="text-sm text-gray-500">v{apk.version}</p>
                </div>
              </div>

              <p className="text-gray-600 text-sm mb-4">{apk.description}</p>

              <div className="space-y-2 mb-4">
                <div className="flex justify-between text-sm">
                  <span className="text-gray-500">Archivo:</span>
                  <span className="font-mono text-gray-700">{apk.filename}</span>
                </div>
                {apk.size && (
                  <div className="flex justify-between text-sm">
                    <span className="text-gray-500">Tamaño:</span>
                    <span className="text-gray-700">{apk.size} MB</span>
                  </div>
                )}
                <div className="flex justify-between text-sm">
                  <span className="text-gray-500">Estado:</span>
                  <span className={`px-2 py-1 rounded-full text-xs ${
                    apk.exists 
                      ? 'bg-green-100 text-green-800' 
                      : 'bg-red-100 text-red-800'
                  }`}>
                    {apk.exists ? 'Disponible' : 'No disponible'}
                  </span>
                </div>
              </div>

              <button
                onClick={() => handleDownload(apk)}
                disabled={!apk.exists}
                className={`w-full flex items-center justify-center px-4 py-2 rounded-lg font-medium transition-colors ${
                  apk.exists
                    ? 'bg-blue-600 hover:bg-blue-700 text-white'
                    : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                }`}
              >
                <DownloadIcon className="w-4 h-4 mr-2" />
                {apk.exists ? 'Descargar' : 'No disponible'}
              </button>
            </div>
          ))}
        </div>

        {apks.length === 0 && (
          <div className="text-center py-12">
            <Info className="w-16 h-16 text-gray-400 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">
              No hay APKs disponibles
            </h3>
            <p className="text-gray-600">
              Contacta al administrador para agregar aplicaciones
            </p>
          </div>
        )}
      </div>
    </div>
  )
}

export default Download
